import React, { useEffect } from 'react';

import Header from '../components/PortalHomePage/header.js';
import HeroSection from '../components/PortalHomePage/HeroSection.js';
import AboutProgram from '../components/PortalHomePage/AboutProgram.js';
import ProgramFeatures from '../components/PortalHomePage/ProgramFeatures.js';
import ProgramJourney from '../components/PortalHomePage/ProgramJourney.js';
import Curriculum from '../components/PortalHomePage/Curriculum.js';
import Eligibility from '../components/PortalHomePage/Eligibility.js';
import WhyChooseUS from '../components/PortalHomePage/WhyChooseUs.js';
import SelectionProcess from '../components/PortalHomePage/SelectionProcess.js';
import FAQ from '../components/PortalHomePage/FAQ.js';
import Footer from '../components/PortalHomePage/Footer.js';
import { extractUTMParameters, storeUTMParameters } from '../utils/utmUtils.js';
import 'bootstrap/dist/css/bootstrap.min.css';


const PortalHomePage = () => {
    // Capture UTM parameters on component mount
    useEffect(() => {
        const utmParams = extractUTMParameters();
        if (utmParams.utm_source || utmParams.utm_medium || utmParams.utm_campaign) {
            // Store UTM parameters only if they exist in the current URL
            storeUTMParameters(utmParams);
            console.log('UTM Parameters captured:', utmParams);
        } else {
            // Clear stored UTM parameters if current URL doesn't have them
            localStorage.removeItem('utm_parameters');
            console.log('No UTM parameters in URL - cleared stored UTM parameters');
        }
    }, []);

    return (
        <>
        <Header />
      <HeroSection />
      <AboutProgram />
      <ProgramFeatures />
      <ProgramJourney />
      <SelectionProcess />
      <Eligibility />
      <Curriculum />
      <WhyChooseUS/>
      <FAQ />
      <Footer />
        </>
    );
}

export default PortalHomePage;